<template>
  <el-config-provider :locale="zhCn">
    <div class="mobile-app-shell">
      <div class="mobile-phone-viewport">
        <!-- Desktop Smartphone Mockup Notch Header -->
        <div class="mobile-status-notch">
          <span class="notch-time">{{ currentTime }}</span>
          <span class="notch-center">{{ notchTitle }}</span>
          <div class="notch-icons">
            <span>5G</span>
            <span>📶</span>
            <span>🔋 100%</span>
          </div>
        </div>

        <!-- Scrollable Screen Content -->
        <div class="mobile-screen-content">
          <router-view v-slot="{ Component }">
            <transition name="page-fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </div>
    </div>
  </el-config-provider>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from 'vue';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { useTraceStore } from './store/useTraceStore';

const currentTime = ref('09:41');

/**
 * 模拟机壳状态栏（仅 PC 预览可见，<=540px 时 display:none）。
 * 原来硬编码「五常龙凤山核心示范基地」，与当前批次的实际基地无关——
 * 预览时看到的是别人的地名，等于在演示页上写错产地。
 */
const traceStore = useTraceStore();
const notchTitle = computed(() => traceStore.baseName || '一物一码全程溯源');

let timer: any = null;

onMounted(() => {
  const updateTime = () => {
    const d = new Date();
    const h = String(d.getHours()).padStart(2, '0');
    const m = String(d.getMinutes()).padStart(2, '0');
    currentTime.value = `${h}:${m}`;
  };
  updateTime();
  timer = setInterval(updateTime, 30000);
});

onUnmounted(() => {
  if (timer) clearInterval(timer);
});
</script>

<style>
/* Page transition */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.page-fade-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.page-fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.notch-icons {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
}

.notch-center {
  font-size: 10px;
  opacity: 0.85;
}
</style>
